import axios from 'axios';

import { Auth } from 'aws-amplify';

import store from '../store/index';


class AuthenticationService {
    public options: any;
    public token: string|null;
    public userGroups: string[];
    public userPermissions: any;
    public userFeatures: any;
    public user: string|null;
    public userEmail: string;

    constructor(options: any) {
        this.user = null;
        this.options = options;
        this.userGroups = [];
        this.userPermissions = {};
        this.userFeatures  = {};
        this.userEmail = '';
        // this.config = config;

        this.token = null;
    }


    public setUsername(name: string) {
      this.userEmail = name;
      store.commit('setUsername', this.userEmail);
    }

    public setUser(cognitoUser: any) {
        this.user = cognitoUser;
        this.userEmail = cognitoUser.attributes.email;
        store.commit('setUsername', this.userEmail);
        const session = cognitoUser.signInUserSession;
        this.token = session.idToken.jwtToken;
        axios.defaults.headers.common.Authorization = `${this.token}`;
        const hasGroups = !!session.accessToken.payload['cognito:groups'];
        this.userGroups = hasGroups ? session.accessToken.payload['cognito:groups'] : [];
        this.userFeatures = session.idToken.payload.features;
        this.processGroups();
      }

      public setUserSession(cognitoUserSession: any) {
        this.token = cognitoUserSession.idToken.jwtToken;
        axios.defaults.headers.common.Authorization = `${this.token}`;
        const hasGroups = !!cognitoUserSession.accessToken.payload['cognito:groups'];
        this.userGroups = hasGroups ? cognitoUserSession.accessToken.payload['cognito:groups'] : [];
        this.userFeatures = cognitoUserSession.idToken.payload.features;
        this.processGroups();
      }

      public setToken(token: any) {
        store.commit('setUsername', this.userEmail);
        this.token = token;
        axios.defaults.headers.common.Authorization = `${this.token}`;
      }

      public checkSession() {
        Auth.currentSession()
          .then((data: any) => {
            this.setToken(data.idToken.jwtToken);
          })
          .catch((err) => err);
      }

      public isAunthicated() {
        return !!this.user;
      }

      private processGroups() {
        this.userPermissions = {};
        const perms: any = {};
        this.userGroups.forEach((group) => {
          const isSysAdmin = group === 'SysAdmin';
          const isDevAdmin = group === 'DevAdmin';
          const isUser = group === 'User';
          const isSystem = group === 'SYSTEM';

          if (isSysAdmin) {
            this.userPermissions.isSysAdmin = isSysAdmin;
            perms.isSysAdmin = true;
            return;
          }
          if (isDevAdmin) {
            this.userPermissions.isDevAdmin = isDevAdmin;
            perms.isDevAdmin = true;
            return;
          }
          if (isUser) {
            this.userPermissions.isUser = isUser;
            perms.isUser = true;
            return;
          }
          if (isSystem) {
            this.userPermissions.isSystem = isSystem;
            perms.isSystem = true;
            return;
          }

          const permissions = group.split('.');
          const groupLvl = permissions.length; // group has no claims
          const isAccountPermission = groupLvl === 3;
          const isClientPermission = groupLvl === 2;
          // const isFeaturePermission = groupLvl === 4;

          const [p, a, c] = permissions;
          if (!perms[c]) { perms[c] = {}; }
          if (!perms[c][a]) { perms[c][a] = {}; }
          perms[c][a][p] = true;

          const client = permissions[groupLvl - 1];
          const doesClientObjectExist = !!this.userPermissions[client];

          if (!doesClientObjectExist) { this.userPermissions[client] = { permissions: [], accounts: {} }; }
          if (isClientPermission) {
            this.userPermissions[client].permissions.push(permissions[groupLvl - 2]);
          }
          if (isAccountPermission) {
            const code = permissions[groupLvl - 2];
            const doesAccountObjectExist = !!this.userPermissions[client].accounts[code];

            if (!doesAccountObjectExist) {
              this.userPermissions[client].accounts[code] = {
                permissions: [], features: {},
              };
            }
            this.userPermissions[client].accounts[code].permissions.push(permissions[groupLvl - 3]);
          }
          //  this.userPermissions[client].accounts[permissions[groupLvl - 2]]
        });
        this.userPermissions.all = perms;
      }
}

export default new AuthenticationService({});
